import {Injectable} from '@angular/core';
import {User} from '../../classes/members/user';

@Injectable()
export class UserService {
    user: User;
    login_user: any;

    constructor() {
    }

    setUser(user) {
        this.user = {
            id: user.id,
            name: user.name,
            branch: user.branch,
            status: user.status,
            role: user.role,
            type: user.type,
            email: user.email,
            mobile: user.mobile,
            level: user.level,
            permission: user.permission
        };
        this.login_user = this.user;
    }

    getUser() {
        return this.user;
    }

    removeUser() {
        this.user = null;
    }

    canAccess(moduleID) {
    }

    getID() {
        return this.user.id;
    }

    isAdmin() {
        return this.user.role == 1;
    }

    isAgent() {
        return this.user.role == 2;
    }

    isUser() {
        return this.user.type == 'user';
    }

    getRole() {
        return this.user.role;
    }

    getBranch() {
        return this.user.branch;
    }
}
